// French for the portfolio board ('#clients'). Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  // where a move's route lands (PAGE_LABEL)
  'the dashboard': 'le dashboard',
  'the clients': 'les clients',
  'the gate': 'le gate',
  'the documents': 'les documents',
  'the register': 'le registre',
  'the agent queue': 'la file d’attente de l’agent',
  'the proposals': 'les propositions',
  'contracting': 'contractualisation',
  'acceptance': 'acceptation',
  'the client portal': 'le portail client',
  'admin': 'admin',
  'the page': 'la page',
  'Open {page} →': 'Ouvrir {page} →',
  'The timeline →': 'La chronologie →',
  'Open the client →': 'Ouvrir le client →',
  'The brief →': 'Le briefing →',

  'That row is not on the board under the current filter — the cell counts the whole register.': 'Cette ligne ne figure pas sur le board sous le filtre actuel — la cellule compte tout le registre.',
  'Name is required': 'Le nom est requis',
  '{name} added': '{name} ajouté',
  'Client archived — it keeps its history and leaves the active list': 'Client archivé — il conserve son historique et quitte la liste active',
  '{label} deleted — {cascade} went with it': '{label} supprimé — {cascade} est parti avec',
  'nothing else': 'rien d’autre',
  'reading…': 'lecture…',
  'roll-up did not answer': 'le récapitulatif n’a pas répondu',
  '“{query}”': '«{query}»',
  'status {status}': 'statut {status}',
  'under': 'sous',

  'Clients': 'Clients',
  'on file': 'enregistrés',
  'engaged': 'avec mandat',
  'board read at {date}': 'board lu le {date}',
  'reading the register…': 'lecture du registre…',
  'the register did not answer': 'le registre n’a pas répondu',
  'New client': 'Nouveau client',
  'ENGAGED': 'MANDATÉ',
  'QUEUED': 'EN ATTENTE',
  'BALL': 'BALLE',
  'QUIET': 'SILENCE',
  'NEW': 'NOUVEAU',
  'All': 'Tous',
  'active': 'actif',
  'dormant': 'dormant',
  'archived': 'archivé',
  'Search name, short name, sector…': 'Rechercher nom, nom court, secteur…',
  'The gate tallies': 'Les décomptes de gate',

  'The board did not answer': 'Le board n’a pas répondu',
  '{endpoint} answered: “{error}”. The client register itself is fine — what failed is the roll-up that ranks it.': '{endpoint} a répondu : «{error}». Le registre des clients lui-même va bien — ce qui a échoué, c’est le récapitulatif qui le classe.',
  'no response': 'aucune réponse',
  'Show the plain list instead': 'Afficher la liste simple à la place',
  'The plain list': 'La liste simple',
  '{n} client': '{n} client',
  '{n} clients': '{n} clients',
  'Names and identities only — no ranking, no gate tallies, no silence. This is the degraded mode.': 'Seulement des noms et des identités — aucun classement, aucun décompte de gate, aucun silence. C’est le mode dégradé.',
  'no sector on the record': 'aucun secteur au dossier',
  'Open →': 'Ouvrir →',
  'Archive — keeps every engagement, contact and document; the client leaves the active list': 'Archiver — conserve chaque mandat, contact et document ; le client quitte la liste active',
  'Archive': 'Archiver',
  'Delete {name} — for a row that should never have existed': 'Supprimer {name} — pour une ligne qui n’aurait jamais dû exister',
  'Delete': 'Supprimer',
  'No clients yet': 'Aucun client pour l’instant',
  'A client is the root of everything: engagements hang off it, and the document library belongs to it. Add the first one, then create an engagement against it.': 'Un client est la racine de tout : les mandats en dépendent, et la bibliothèque de documents lui appartient. Ajoutez le premier, puis créez un mandat pour lui.',
  'Nothing matches {what}': 'Rien ne correspond à {what}',
  '{n} client is on file. The filter, not the register, is empty.': '{n} client est enregistré. C’est le filtre qui est vide, pas le registre.',
  '{n} clients are on file. The filter, not the register, is empty.': '{n} clients sont enregistrés. C’est le filtre qui est vide, pas le registre.',
  'Clear the filter': 'Réinitialiser le filtre',

  'Needs a move': 'Nécessite un coup',
  '{n} move': '{n} coup',
  '{n} moves': '{n} coups',
  'Ranked by the rule that fired, not by name. The rule and its wording are the client page’s own — this board calls the same code.': 'Classé selon la règle déclenchée, pas selon le nom. La règle et son libellé appartiennent à la page client — ce board appelle le même code.',
  'Nothing queued': 'Rien en attente',
  'No rule fired. A gate tally and a silence are not rules — read them here. Quiet is {days} days or more with nothing recorded.': 'Aucune règle déclenchée. Un décompte de gate et un silence ne sont pas des règles — lisez-les ici. Silencieux signifie {days} jours ou plus sans rien d’enregistré.',
  'Not engaged': 'Sans mandat',
  '{n} new item': '{n} nouvel élément',
  '{n} new items': '{n} nouveaux éléments',
  'Hide these rows': 'Masquer ces lignes',
  'Show these rows': 'Afficher ces lignes',
  'No live engagement, so no gate and no queue beyond “create one”.': 'Aucun mandat en cours, donc aucun gate et aucune file d’attente au-delà de «en créer un».',
  'hide ▴': 'masquer ▴',
  'show ▾': 'afficher ▾',
  'NEW counts from your last visit; where a client has never been opened, from {days} days back.': 'NOUVEAU compte depuis votre dernière visite ; là où un client n’a jamais été ouvert, depuis {days} jours en arrière.',

  'Name, short name and sector are what the list scans. Legal name and address are what the SOW prints — the record surface takes them, and the brief will show {dash} until it does.': 'Nom, nom court et secteur sont ce que la liste parcourt. Raison sociale et adresse sont ce que le descriptif des prestations (SOW) imprime — le dossier les recueille, et le briefing affiche {dash} jusque-là.',
  'Name': 'Nom',
  'Short name': 'Nom court',
  'Sector': 'Secteur',
  'Notes': 'Notes',
  'The short name seeds derived engagement codes (e.g. {example}).': 'Le nom court sert de base aux codes de mandat dérivés (p. ex. {example}).',
  'Cancel': 'Annuler',
  'Create client': 'Créer le client',

  'Archive client': 'Archiver le client',
  '{label} cannot be deleted': '{label} ne peut pas être supprimé',
  'Delete {label}': 'Supprimer {label}',
  'client': 'client',
  'Archive instead': 'Archiver à la place',
  'Deleting…': 'Suppression…',
  'Delete permanently': 'Supprimer définitivement',
  'Archive “{label}”? Engagements and history are preserved — the client simply drops out of the active list. Nothing is removed, and you can bring it back by setting the status to active.': 'Archiver «{label}» ? Les mandats et l’historique sont conservés — le client sort simplement de la liste active. Rien n’est supprimé, et vous pouvez le ramener en repassant son statut à actif.',
  'Delete “{label}” outright? This is for a client that should never have existed — a real one that has finished gets archived instead.': 'Supprimer «{label}» définitivement ? Ceci est pour un client qui n’aurait jamais dû exister — un client réel arrivé à son terme est archivé à la place.',
  '{count} {what} go with it': '{count} {what} partent avec',
  'Nothing else hangs off this client.': 'Rien d’autre ne dépend de ce client.',
  'Including {codes} with every requirement and run inside them — and the client’s document library, stored files included.': 'Y compris {codes} avec toutes les exigences et exécutions qu’ils contiennent — ainsi que la bibliothèque de documents du client, fichiers stockés inclus.',
  'Immediate and irreversible. The audit log keeps the record.': 'Immédiat et irréversible. La piste d’audit conserve la trace.',

  // row parts
  'nothing on the client record': 'rien au dossier client',
  'Qualify': 'Qualification',
  'Discovery': 'Discovery',
  'Design': 'Conception',
  'Contracting': 'Contractualisation',
  'Mobilise': 'Mobilisation',
  'Implement': 'Réalisation',
  'Acceptance': 'Acceptation',
  'Handover': 'Transfert',
  'Close (phase)': 'Clôture',
  '{gate} tally unknown': '{gate} décompte inconnu',
  '{gate} {met} of {total} automatic': '{gate} {met} sur {total} automatiques',
  '+{n} archived': '+{n} archivés',
  'Ball': 'Balle',
  'THEM': 'CHEZ EUX',
  'US': 'CHEZ NOUS',
  '{ref} open {days} d': '{ref} ouvert depuis {days} j',
  'no open commitment': 'aucune promesse ouverte',
  'Last contact': 'Dernier contact',
  'never': 'jamais',
  'd': 'j',
  '{n} more move on the brief': '{n} coup de plus dans le briefing',
  '{n} more moves on the brief': '{n} coups de plus dans le briefing',
  '{n} more on the brief': '{n} de plus dans le briefing',
  'Open the gate →': 'Ouvrir le gate →',
  'More for {name}': 'Plus pour {name}',
  'Archive — keeps the history': 'Archiver — conserve l’historique',
  'Delete {name}…': 'Supprimer {name}…',
  '{n} document': '{n} document',
  '{n} documents': '{n} documents',
  '{n} contact': '{n} contact',
  '{n} contacts': '{n} contacts',
  '{n} archived engagement': '{n} mandat archivé',
  '{n} archived engagements': '{n} mandats archivés',
  '{what} · last contact {date}': '{what} · dernier contact {date}',
  'nothing on the record at all': 'vraiment rien au dossier',
  'new': 'nouveau',
  'reading the board…': 'lecture du board…',
}, 'ClientsPage');
